export default {
  LIST_FETCHED: 'RAW_CONTENT_LIST_FETCHED',
  LIST_LOAD: 'RAW_CONTENT_LIST_LOAD',
  TEMPLATES_FETCHED: 'RAW_CONTENT_TEMPLATES_FETCHED',
  TEMPLATES_LOAD: 'RAW_CONTENT_TEMPLATES_LOAD',
  DETAIL_FETCHED: 'RAW_CONTENT_DETAIL_FETCHED',
  BUTTON_LOAD: 'RAW_CONTENT_BUTTON_LOAD',
};
